var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLanguage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 4C30 8 31.8455 16.5841 32 24C31.8455 31.4159 30 40 24 44M24 4C18 8 16.1545 16.5841 16 24C16.1545 31.4159 18 40 24 44M24 4C12.9543 4 4 12.9543 4 24M24 4C35.0457 4 44 12.9543 44 24M24 44C35.0457 44 44 35.0457 44 24M24 44C12.9543 44 4 35.0457 4 24M44 24C40 30 31.4159 31.8455 24 32C16.5841 31.8455 8 30 4 24M44 24C40 18 31.4159 16.1545 24 16C16.5841 16.1545 8 18 4 24",
    stroke: "#CFFFFF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLanguage);
export default __webpack_public_path__ + "static/media/language.1ec51aec350c3eeab934cef349c09e58.svg";
export { ForwardRef as ReactComponent };